"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.failureListener = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var toast_1 = require("@caddigital/sok-reducers/lib/actions/toast");
function debounceByAction(delay) {
    var source$ = this;
    return new rxjs_1.Observable(function (observer) {
        // Using an object as the default value
        // so that the first time we check it
        // if its the same its guaranteed to be false
        // because every object has a different identity.
        // Can't use null or undefined because source may
        // emit these!
        var types = {};
        return source$
            .pipe((0, operators_1.debounce)(function (value) {
            if (value && value.type) {
                // If the last value has the same identity we'll
                // actually debounce
                var lastSeen = types[value.type];
                var time = Date.now() - lastSeen;
                if (lastSeen !== undefined && time < delay) {
                    return (0, rxjs_1.timer)(delay);
                }
                else {
                    types[value.type] = Date.now();
                    // This will complete() right away so we don't actually debounce/buffer
                    // it at all
                    return (0, rxjs_1.empty)();
                }
            }
            return (0, rxjs_1.empty)();
        }))
            .subscribe(observer);
    });
}
var failureListener = function (action$, store) {
    return action$.pipe((0, operators_1.filter)(function (action) { return /(FAILED|FAILURE)$/.test(action.type); }), function (source$) { return debounceByAction.call(source$, 5000); }, (0, operators_1.mergeMap)(function (action) {
        var error = action ? action.payload : undefined;
        if (error !== undefined && error.type) {
            if (error.type === 'CONNECTION_ERROR') {
                return (0, rxjs_1.of)((0, toast_1.addNewToast)((0, translation_1.getLocalization)('toast/connectionError/title'), (0, translation_1.getLocalization)('toast/connectionError/message'), 'FAILURE', []));
            }
        }
        return (0, rxjs_1.empty)();
    }));
};
exports.failureListener = failureListener;
